/* eslint-disable */
import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import * as qs from "qs";

const endpoint = API_ENDPOINT + "/admin";

@Component
export default class ProfilesMixin extends Vue {
  getProfiles(tag: string) {
    const url = `${endpoint}/profiles.json`;
    const params = { page: { size: "all" } };

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
      params,
      paramsSerializer: (params: any) => {
        return qs.stringify(params);
      },
    });
  }

  getProfile(id: string, tag: string) {
    const url = `${endpoint}/profiles/${id}.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  createProfile(data: any, tag: string) {
    const url = `${endpoint}/profiles.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: data,
    });
  }

  updateProfile(id: string, data: any, tag: string) {
    const url = `${endpoint}/profiles/${id}.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "PUT",
      data: data,
    });
  }

  deleteProfile(id: string, tag: string) {
    const url = `${endpoint}/profiles/${id}.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "DELETE",
    });
  }

  addProfileUser(id: string, data: any, tag: string) {
    const url = `${endpoint}/profiles/${id}/relationships/users.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: data,
    });
  }

  removeProfileUser(id: string, userId: string, tag: string) {
    const url = `${endpoint}/profiles/${id}/relationships/users/${userId}.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "DELETE",
    });
  }
}
